export default "__VITE_ASSET__Crdrlv4g__"